import { render, staticRenderFns } from "./data-updates.vue?vue&type=template&id=52bc98f0"
import script from "./data-updates.vue?vue&type=script&lang=js"
export * from "./data-updates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports